import {createDeleteMethod, createGetAllMethod, createPostMethod, createPutMethod,} from "../core/factory";
import {entityType} from "./module";

export const getAllProperties = () => createGetAllMethod(entityType)
export const deleteProperty = (payload) => createDeleteMethod(entityType, payload)
export const createProperty = (payload) => createPostMethod(entityType, payload)
export const updateProperty = (payload) => createPutMethod(entityType, payload)
